import { useMemo } from 'react';
import { ChangeAccountCategoryPopup, DiscardAccountPopup } from '../containers/drawer/Popups';
import { RemoveReasonOptionsByType } from '../containers/drawer/ServiceAccountRemoveReason';
import { ServiceAccount } from '../ServiceAccountsTypes';

export type PopupType = 'change' | 'hide' | 'discard';

export interface ActionPopupsProps {
    openPopup: 'change' | 'hide' | 'discard';
    onClosePopup: () => void;
    onRemove: (
        serviceAccounts: Pick<ServiceAccount, 'id' | 'guid' | 'is_protected' | 'display_name'>[],
        hide: boolean,
        misclassification: boolean,
        reason?: string,
        otherReason?: string,
        furtherDetails?: string
    ) => void;
    serviceAccounts: Pick<ServiceAccount, 'id' | 'guid' | 'is_protected' | 'display_name'>[];
    onReinstate: (category?: string) => void;
}

const ActionPopups = ({ openPopup, onClosePopup, onRemove, serviceAccounts, onReinstate }: ActionPopupsProps) => {
    const isProtected = useMemo(() => serviceAccounts.some((account) => account.is_protected), [serviceAccounts]);
    return (
        <>
            <ChangeAccountCategoryPopup open={openPopup === 'change'} onClose={onClosePopup} onApprove={onReinstate} />
            <DiscardAccountPopup
                title="Misclassification"
                open={openPopup === 'discard'}
                onClose={onClosePopup}
                onApprove={(reason?: string, otherReason?: string, furtherDetails?: string) =>
                    onRemove(serviceAccounts, false, true, reason, otherReason, furtherDetails)
                }
                isProtected={isProtected}
                descriptionMessage={
                    'Mark accounts as Misclassified if flagged incorrectly as an NHI. View misclassified accounts in the Discarded tab.\nThe virtual fencing policy will no longer apply to these accounts.'
                }
                reasonOptions={RemoveReasonOptionsByType.remove}
            />
            <DiscardAccountPopup
                title="Hide"
                open={openPopup === 'hide'}
                onClose={onClosePopup}
                onApprove={(reason?: string, otherReason?: string, furtherDetails?: string) =>
                    onRemove(serviceAccounts, true, false, reason, otherReason, furtherDetails)
                }
                isProtected={isProtected}
                descriptionMessage={
                    'Hide accounts that do not pose a security risk. View hidden accounts in the Discarded tab.\nThe virtual fencing policy will no longer apply to these accounts.'
                }
                reasonOptions={RemoveReasonOptionsByType.hide}
            />
        </>
    );
};
export default ActionPopups;
